import { create } from 'zustand';

interface ISejamCheckStore {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}

export const useSejamCheckStore = create<ISejamCheckStore>((set) => ({
  isOpen: false,

  setOpen: (open) => set({ isOpen: open }),
}));
